<template>
	<div class="pt-6">
		<div class="flex-row-align-center">
			<div class="color-gy-9 font-h3-medium">下载安装软件，即可打通官方达人广场(多平台共用同插件)</div>
			<div class="color-gy-7 fz-12 ml-8">达人可手动添加至达人CRM，同时获取达人联系方式，</div>
			<div class="yx-color-primary fz-12 cursor-pointer" @click="handleGoTutorial(1)">安装教程</div>
		</div>
		<div class="yx-background flex-row-align-center pl-24 pr-24 pt-16 pb-16 mt-16">
			<div class="flex-column flex-align-center">
				<div class="clueSeas-compress-icon">
					<span v-if="currentVersion && latestVersion != currentVersion" class="clueSeas-compress-publish yx-color-white">有更新</span>
					<img src="@/assets/public/clueSeas-compress-img.png" alt="" />
				</div>
				<div class="color-gy-7 fz-12 mt-4">插件安装包.zip</div>
			</div>
			<el-popover placement="top" width="492" trigger="hover" popper-class="plug-popover">
				<div>
					<div class="p-24">
						<div class="yx-color-text-secondary font-h4-regular">
							插件仅支持在主流浏览器使用，请确认您的电脑所安装浏览器是否支持，支持插件浏览器如下:
						</div>
						<div class="yx-color-text-primary font-h4-regular mt-24">
							<p class="flex-row-align-center">
								<i class="circle mr-4"></i>
								苹果电脑:谷歌浏览器
							</p>
							<p class="flex-row-align-center">
								<i class="circle mr-4"></i>
								Windows电脑:谷歌浏览器、360浏览器、遨游浏览器、Edge浏览器
							</p>
						</div>
					</div>
				</div>
				<el-button slot="reference" class="ml-32" type="primary" size="small" icon="el-icon-download" @click="checkPlug"> 下载安装包 </el-button>
			</el-popover>

			<el-button v-if="plugOk" class="ml-12" size="small" icon="el-icon-top-right" @click="handleGoDy">
				已安装，打开“{{ platformId | formatPlatformName }}”达人广场
			</el-button>
		</div>
		<!-- 下载插件提示框 -->
		<PlugInstallTips ref="plugInstallTips" />
		<el-dialog title="提示" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
			<span>
				检测到将在同浏览器上安装[超佣团]和[热度云]插件，两个插件暂时无法同时打开，继续下载新插件后原已安装插件将自动关闭(如需打开请查看
				<a href="https://yangxuan.feishu.cn/docx/CT4idMJwMoudLrxsqYwcoIRlnYb" target="_blank" class="yx-color-primary">插件管理教程</a>
				)，确认是否要继续下载？
			</span>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button
					type="primary"
					@click="
						dialogVisible = false;
						handleDownLoad();
					"
				>
					确 定
				</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import browser from 'browser-tool';
import { getPlugVersionApi, talentReportLog } from '@/api/talentCRM';
import PlugInstallTips from './plugInstallTips';
import { callPlug } from '@/utils/bridge';

export default {
	props: {
		platformId: {
			type: Number,
			default: 0,
		},
	},
	components: {
		PlugInstallTips,
	},
	data() {
		return {
			dialogVisible: false,
			plugOk: false,
			currentVersion: '',
			latestVersion: '',
			downloadUrl: '',
		};
	},
	async mounted() {
		this.queryUsing();
		this.plugOk = window.cytPlugOk;
		const { version } = await callPlug('plugGetVersion');
		let bigVersion = version.split('.');
		bigVersion.pop();
		bigVersion = bigVersion.join('.');
		// console.log('插件版本', bigVersion);
		this.currentVersion = bigVersion;
	},
	methods: {
		checkPlug() {
			// 是否安装插件
			const isInstallplug = window.rdyplugOk;
			if (isInstallplug) {
				this.dialogVisible = true;
			} else {
				this.handleDownLoad();
			}
		},
		async queryUsing() {
			try {
				const { fileManage } = await getPlugVersionApi();
				const { resource_version, resource_value } = fileManage;
				let bigVersion = resource_version.split('.');
				bigVersion.pop();
				bigVersion = bigVersion.join('.');
				this.latestVersion = bigVersion;
				// console.log('最新版本', bigVersion);
				this.downloadUrl = resource_value;
			} catch (error) {
				// console.log(error);
			}
		},
		handleGoTutorial(type) {
			let link = {
				1: 'https://yangxuan.feishu.cn/docx/LLT1dR8lQoJVoQxf2Bbc8Zacnng?from=from_copylink',
				2: 'https://yangxuan.feishu.cn/docx/LLT1dR8lQoJVoQxf2Bbc8Zacnng?from=from_copylink',
			};
			window.open(link[type], '_blank');
		},
		async handleDownLoad() {
			// console.log('浏览器内核', browser().browser);
			if (!['Chrome', 'Edge', 'Chromium', '360SE', '360EE'].includes(browser().browser)) {
				return this.$refs.plugInstallTips.show();
			}
			window.open(this.downloadUrl + '?cache=' + Math.random(), '_blank');
			await talentReportLog();
		},
		handleGoDy() {
			const temPF_url = {
				[dataMap.PLATFORM_DY.value]: 'https://buyin.jinritemai.com/dashboard/servicehall/daren-square',
				[dataMap.PLATFORM_KS.value]: 'https://cps.kwaixiaodian.com/pc/leader/zone-cps/promoter_square',
			};
			window.open(temPF_url[this.platformId], '_blank');
		},
	},
};
</script>

<style lang="less" scoped>
.clueSeas-compress-icon {
	width: 48px;
	position: relative;

	img {
		width: 100%;
	}

	.clueSeas-compress-publish {
		background: linear-gradient(to right, rgba(255, 176, 111, 1), rgba(255, 128, 128, 1));
		border-radius: 4px;
		border-bottom-left-radius: 1px;
		padding: 2px 3px;
		border: 1px solid #fff;
		position: absolute;
		top: -8px;
		right: -28px;
		transform: scale(0.84);
		font-size: 12px;
		font-weight: bold;
	}
}
</style>
